import React, { useEffect } from "react";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../../AtomStore/store";
import { fetchPastRequests } from "../../../QueryFunctions/queryfunction";
import PastRequestItem from "./PastRequestItem";
import ListEmptyComponent from "../../../Layout/LoggedInLayout/ListEmptyComponent";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";

const Request = () => {
  const { useQueryWrapper } = useRequestProcessor();

  const [activeChild] = useAtom(activeChildDetail);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    console.log("[Past Request] Past Request  for child:", activeChild?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    data: pastRequest,

    isLoading,
    refetch,
  } = useQueryWrapper(
    ["pastRequest", "pastRequest" + activeChild?.id],
    () => {
      console.log("[Past Request] Calling API: /parentapp/requestList", {
        child_id: activeChild?.id,
      });
      return fetchPastRequests();
    },
    {
      onSuccess: (data) => {
        console.log("[Past Request] Past Request response:", data);
      },
    }
  );

  if (Array.isArray(pastRequest) && pastRequest.length > 0) {
    return (
      <ul className="pt-16 [@media(min-width:640px)and(max-width:768px)]:pt-4 md:pt-2 px-2 lg:grid lg:grid-cols-2 lg:gap-x-10 lg:gap-y-2">
        {pastRequest?.map((item, index) => (
          <PastRequestItem
            md={6}
            item={item}
            key={index}
            index={index}
            refetch={refetch}
          />
        ))}
      </ul>
    );
  } else if (isLoading) {
    return (
      <>
        <SpinnerLoading />
        <div className="text-center mt-12">
          <ListEmptyComponent
            heading={isLoading ? "Loading..." : "No Data Found"}
          />
        </div>
      </>
    );
  }
};

export default Request;
